import React from 'react';
import Text from 'components/Text';
export default function Description(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "dt",
    overflow: "wrap",
    maxWidth: "100%"
  }, title), /*#__PURE__*/React.createElement(Text, {
    as: "dd",
    overflow: "wrap",
    maxWidth: "100%"
  }, children));
}